module.exports = __webpack_public_path__ + "static/scale-model-of-visit-topeka-in-topeka-kansas-6271779d1dcd224e0303369b4be97a57.png";